import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';
import { getBrannanMobileMediaQuery } from '../../../../LayoutBrannan.theme';

export const StyledRoot = styled(Box)`
  width: 100%;
  ${({ theme }) => {
    return {
      [getBrannanMobileMediaQuery(theme)]: {
        display: 'flex',
        // Column keeps the single full-width child on the cross axis so it can't be
        // squeezed to min-content (text collapsing to one char per line, map/hotels
        // crushed) — the row default did that on Classic-nav/native where-to-stay.
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
    };
  }}
`;

export const StyledTitle = styled(Box)``;

const titleStyles: StyleSystemProps = {
  maxWidth: ['90%', null, null, 720],
  marginX: 'auto',
  marginY: [70, 70, 'unset'],
  textAlign: 'center',
  position: 'relative',
};

export const styles = {
  title: titleStyles,
};
